import { DatePipe } from '@angular/common';
import {Component,ElementRef,OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, SelectItem, MenuItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { User } from 'src/app/auth/models';
import { JwtService } from 'src/app/auth/services';
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { SharedService } from 'src/app/shared/services';
import { IEmailDeliveryReport } from '../../models';
import { EmailDeliveryReportService } from '../../services/email-delivery-report.service';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';

@Component({
  selector: 'app-email-delivery-report',
  templateUrl: './email-delivery-report.component.html',
  styleUrls: ['./email-delivery-report.component.css'],
  providers: [DialogService, ConfirmationService, MessageService],

})
export class EmailDeliveryReportComponent implements OnInit {
emailDeliveryReportForm : FormGroup;
sortField:string = 'emailSentDate';
  sortOrder:string = 'desc';
  oldSortField:string = 'emailSentDate';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  // matchModeOptions: SelectItem[];
  // matchModeOptionsForDate: SelectItem[];
  // matchModeOptionsForNumeric: SelectItem[];
  // matchModeOptionsForDropdown: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  emailDeliveryReportSearchParam:IGlobalSearchParam;
  showAddRuleButton:boolean = false;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  userActivityLogList;
  isshowpaginator:boolean=true;
  loggedInUserProfile: User;
  dateRange:Date[];
  minDate: Date;
  maxDate: Date;
  categoryName;
  // selectedReportIds;
  // selectedReportEditIds;
  // selectedReportEditIdsOnChange;
  // selectedReportValid: boolean = true;
  startDate;
  endDate;
  // arrAllReportTypes;
  showTable:boolean = false;
  // showIneligibleApplicants: boolean = true ;
  emailDeliveryReport = 'EmailDeliveryReport.xlsx';
  allColumns = [
    { value: '#', header: '#' },
    { value: 'emailTemplateName', header: 'Email Name' },
    { value: 'emailSubject', header: 'Email Subject' },
    { value: 'emailSentDate', header: 'Email Sent Date' },
    { value: 'vendorName', header: 'Company' },
    { value: 'emailSentTo', header: 'Sent To' },
    { value: 'userName', header: 'User' },
    { value: 'startDate', header: 'Start Date' },
    { value: 'endDate', header: 'End Date' },
  ];

  selectedColumns = [
    { value: '#', header: '#' },
    { value: 'emailTemplateName', header: 'Email Name' },
    { value: 'emailSubject', header: 'Email Subject' },
    { value: 'emailSentDate', header: 'Email Sent Date' },
    { value: 'vendorName', header: 'Company' },
    { value: 'emailSentTo', header: 'Sent To' },
    { value: 'userName', header: 'User' },
    { value: 'startDate', header: 'Start Date' },
    { value: 'endDate', header: 'End Date' },
  ];
  emailDeliveryReportSpinner = 'emailDeliveryReportSpinner';
  @ViewChild('dt2', { static: true }) table: any;
  emailSentDateFilterValue:any;
  startDateFilterValue: any;
  endDateFilterValue: any;
  showToggle:boolean;
  emailDeliveryReportList;
  startDateSelectedDate: Date = new Date();
  menuItems: MenuItem[];
  activeItem: MenuItem;

  constructor(
    private emailDeliveryReportService: EmailDeliveryReportService,
    public sharedService: SharedService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private jwtService: JwtService,
    private router: Router,
  ) 
  { 
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
   }

  ngOnInit(): void {
    this.checkViewPermission();
    this.reactiveForm();
    this.maxDate = new Date();
    this.startDateSelectedDate = new Date();
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    this.menuItems = [
      {label: 'Email Delivery Report', routerLink: ["/report/email-delivery-report"]},
      {label: 'Emails Sent to Anonymous Users', routerLink: ["/report/email-report-anonymous-users"]},
  ];
  this.activeItem = this.menuItems[0];
    this.filterCondition=[
      {fieldName:"emailTemplateName", type:"basic"},
      {fieldName:"emailSubject", type:"basic"},
      {fieldName:"emailSentDate", type:"date"},
      {fieldName:"vendorName", type:"basic"},
      {fieldName:"emailSentTo", type:"basic"},
      {fieldName:"userName", type:"basic"},
      {fieldName:"startDate", type:"date"},
      {fieldName:"endDate", type:"date" },
    ];
  }

reactiveForm(){
this.emailDeliveryReportForm = this.formBuilder.group({
  startDate : new FormControl(null, [Validators.required]),
  endDate : new FormControl(null, [Validators.required]),
})
}
isShowColumns(columnName){
  var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
  if(tempColumn.length == 1){
    return true;
  }
  return false;
}
checkViewPermission() {
  var permission =this.jwtService.getLoggedInUserProfile();
  var allowedUser = this.sharedService.isMspUser();
  if(permission ==0 || allowedUser == false || allowedUser == undefined)
  {
   this.router.navigateByUrl('/login');
  }
}
onSelectStartDate(event) {
  // this.maxDate = new Date(this.datePipe.transform(event, 'yyyy-MM-dd'));
  const localDateString = event.toLocaleDateString('En-en');
  this.startDateSelectedDate = new Date(localDateString);
  var selectedStartDate = new Date(this.startDateSelectedDate);
  this.startDateSelectedDate = selectedStartDate;
  this.emailDeliveryReportForm.controls['endDate'].setValue(undefined);
}
loadEmailDeliveryReportList(event:LazyLoadEvent)
  { 
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getEmailDeliveryReport();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
   
    if(this.filters["emailSentDate"] != undefined)
    {
    if(this.filters["emailSentDate"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
  }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='emailSentDate';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getEmailDeliveryReport();
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }
  generateEmailDeliveryReport({ value } : { value: IEmailDeliveryReport}, table:Table){
    table.clear();
    this.emailSentDateFilterValue = undefined;
    this.startDateFilterValue = undefined;
    this.endDateFilterValue = undefined;
    this.appliedFilters=[];
    this.startDate = value.startDate;
    this.endDate = value.endDate;
    this.appliedFilters.push({ field:"loggedInUserId", matchMode:"custom-equals", value:this.loggedInUserProfile.uid }); 
    this.showTable = true;
    this.getEmailDeliveryReport();
  }
  getEmailDeliveryReport(){
    if(this.startDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchStartDate", matchMode:"custom-equals", value:this.datePipe.transform(this.startDate,"MM-dd-yyyy")});
    }
    if(this.endDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchEndDate", matchMode:"custom-equals", value:this.datePipe.transform(this.endDate,"MM-dd-yyyy")}); 
    }
    this.emailDeliveryReportSearchParam = 
    {
      pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
    }
    console.log('parma',this.emailDeliveryReportSearchParam)
       this.spinner.show();
    this.emailDeliveryReportService.searchEmailDeliveryReport(this.emailDeliveryReportSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.emailDeliveryReportList =data;
      console.log('vn',this.emailDeliveryReportList);
      this.isshowpaginator=this.emailDeliveryReportList.length>0?true:false;
      this.totalRecords = (this.emailDeliveryReportList === null || this.emailDeliveryReportList === undefined || this.emailDeliveryReportList.length <= 0 )? 0 : data[0].totalCount;
      console.log(this.totalRecords);
      this.spinner.hide();
     });
  }
  clear(table:Table)
  {
    console.log(table);
    table.clear();
    this.reactiveForm();
    this.appliedFilters = [];
    this.emailDeliveryReportList =[];
    this.isshowpaginator=false;
    this.emailSentDateFilterValue = undefined;
    this.startDateFilterValue = undefined;
    this.endDateFilterValue = undefined;
    this.startDateSelectedDate = new Date();
    // this.pageNo =1;
    // this.pageSize =10;
    // this.oldPageNo =1;
    // this.oldPageSize =10;
    // this.totalRecords = 0;
    // this.sortField = 'createdOn';
    // this.sortOrder = 'desc';
    // this.oldSortField = 'createdOn';
    // this.oldSortOrder = 'desc';
    this.showTable = false;
  }
  applyFilterNew() {
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }

  applyFilter() {
    //  console.log(this.filters);
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "true"
              })
            }
            else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: "false"
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          console.log("filter type is basic");
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              console.log("filter field name is " + [this.filterCondition[i].fieldName][0]);
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            // for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
            //   if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
            //     this.appliedFilters.push({
            //       field: this.filterCondition[i].fieldName,
            //       matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
            //       value: this.datePipe.transform(this.filters[this.filterCondition[i].fieldName][j].value, "MM-dd-yyyy")
            //     })
            // }

            if (this.filterCondition[i].fieldName == "emailSentDate") {
              this.dateFilterValueSet(this.emailSentDateFilterValue, "emailSentDate")
            }

            if (this.filterCondition[i].fieldName == "startDate") {
              this.dateFilterValueSet(this.startDateFilterValue, "startDate")
            }

            if (this.filterCondition[i].fieldName == "endDate") {
              this.dateFilterValueSet(this.endDateFilterValue, "endDate")
            }
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
          }
        }
        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
      }
  this.getEmailDeliveryReport();
    }
  }

  emailSentDateFilterData(e: any) {
    this.emailSentDateFilterValue = e;
    this.applyFilterNew();
  }

  startDateFilterData(e: any) {
    this.startDateFilterValue = e;
    this.applyFilterNew();
  }

  endDateFilterData(e: any) {
    this.endDateFilterValue = e;
    this.applyFilterNew();
  }

  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datePipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.emailSentDateFilterValue = undefined;
    this.startDateFilterValue = undefined;
    this.endDateFilterValue = undefined;
    // this.applyFilter();
    this.getEmailDeliveryReport();
  }

  exportEmailDeliveryReport(){
    if(this.startDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchStartDate", matchMode:"custom-equals", value:this.datePipe.transform(this.startDate,"MM-dd-yyyy")});
    }
    if(this.endDate !=undefined)
    {
      this.appliedFilters.push({ field:"searchEndDate", matchMode:"custom-equals", value:this.datePipe.transform(this.endDate,"MM-dd-yyyy")}); 
    }

    this.applyFilter();
    this.emailDeliveryReportSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       this.spinner.show();
    this.emailDeliveryReportService.exportEmailDeliveryReport(this.emailDeliveryReportSearchParam).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob],"EmailDeliveryReport.xlsx", { type: res.body.type });
      fs.saveAs(file);
      });
      this.spinner.hide();
  }
}
